export interface PcrStatusBadgeConfig {
    color: string;
    label: string;
}

const STATUS_TO_LABEL: Record<string, string> = {
    Created: 'New Request',
    Pending: 'Interim Price Suggested',
    PendingSupplier: 'Interim Price Suggested',
    ApprovedSupplier: 'Interim Price',
    Approved: 'Approved',
    ApprovedWithTemporaryPrice: 'Interim Price Approval',
    Declined: 'Declined',
};

export function getPcrStatusBadge(latestStatus: string): PcrStatusBadgeConfig {
    const label = STATUS_TO_LABEL[latestStatus] ?? latestStatus;

    if (latestStatus === 'Declined') {
        return { color: 'red', label };
    }
    if (
        latestStatus === 'Approved' ||
        latestStatus === 'ApprovedWithTemporaryPrice'
    ) {
        return { color: 'green', label };
    }
    if (latestStatus === 'ApprovedSupplier') {
        return { color: 'blue', label };
    }
    if (
        latestStatus === 'Pending' ||
        latestStatus === 'PendingSupplier' ||
        latestStatus === 'Created'
    ) {
        return { color: 'blue', label };
    }

    return { color: 'gray', label };
}
